// Depends
import { group } from '@/helpers/routes'
import { routes as patient } from './loading-page'
import { routes as profileProfessional } from './profile-professional'
import { routes as profileCompany } from './profile-company'
import { routes as profileCompanyProfessional } from './profile-company-professional'

export default [
  ...group('/patient', [
    ...patient
  ]),
  ...profileProfessional,
  ...profileCompany,
  ...profileCompanyProfessional
]



// WEBPACK FOOTER //
// ./src/app/patient/routes.js